/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'

import './support.scss'

import Header from '../../components/Header'
import Footer from '../../components/footer'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { post } from '../../services/https'

import { useNavigate } from 'react-router-dom'

export default function Support() {
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [part, setPart] = useState('')

  const [alertSubject, setAlertSubject] = useState(false)
  const [alertMessage, setAlertMessage] = useState(false)
  const [alertPart, setAlertPart] = useState(false)
  const [user, setUserId] = useState('')

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    post('/api/front/users/verify', {
      token: localStorage.getItem('token')
      }).then(response => {
        setUserId(response.data.data.userId)
      })
  }, [])

  const sendFormHanlder = (e) => {
    e.preventDefault()

    if (subject.length > 3) {
      setAlertSubject(false)
    } else {
      setAlertSubject(true)
    }

    if (message.length > 5) {
      setAlertMessage(false)
    } else {
      setAlertMessage(true)
    }

    if (part.length > 2) {
      setAlertPart(false)
    } else {
      setAlertPart(true)
    }

    if (subject.length > 3 && message.length > 5 && part.length > 2) {
      setLoading(true)
      post('/api/front/supports', {
        subject,
        message,
        part,
        user
      }).then(response => {
        if (response.data.success) {
          notify('success', 'پیغام با موفقیت ارسال شد')
          setTimeout(() => {
            navigate('/profile')
          }, 4000)
        }
      })
    }
  }

  return (
    <div id='SignUp'>
      <ToastContainer rtl />
      <Header name={'رستوران کانولی'} />
      <div className='body'>
      </div>
      <div className='scroll'>
        <form action=''>
          <div className='input'>
            <label htmlFor=''>موضوع :</label>
            <input onChange={e => setSubject(e.target.value)} type='text' name='' id='from' placeholder='موضوع' />
            <small style={alertSubject ? {} : { display: 'none' }}>موضوع باید وارد شود</small>
          </div>
          <div className='input'>
            <label htmlFor=''>بخش :</label>
            <select onChange={e => setPart(e.target.value)} name="" id="">
              <option value="">انتخاب کنید</option>
              <option value="مالی">مالی</option>
              <option value="آشپزخانه">آشپزخانه</option>
              <option value="مدیریت">مدیریت</option>
              <option value="فنی">فنی</option>
            </select>
            <small style={alertPart ? {} : { display: 'none' }}>بخش باید وارد شود</small>
          </div>
          <div className='input'>
            <label htmlFor=''>پیغام :</label>
            <textarea cols={6} rows={6} onChange={e => setMessage(e.target.value)} name='' id='from' placeholder='پیغام شما ...'></textarea>
            <small style={alertMessage ? {} : { display: 'none' }}>حداقل 6 کاراکتر</small>
          </div>
          <button style={loading ? {display: 'none'} : {}} onClick={sendFormHanlder}>
            <span>ارسال</span>
          </button>
        </form>
      </div>
      <Footer page={''} />
    </div>
  )
}
